/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientSearchAddressResponseDto = {
    /**
     * Address ID
     */
    id: string;
    /**
     * Type of address
     */
    addressType?: ClientSearchAddressResponseDto.addressType | null;
    /**
     * Unit and street
     */
    unitStreet: string;
    /**
     * Suburb
     */
    suburb: string;
    /**
     * City
     */
    city: string;
    /**
     * Postcode
     */
    postcode: string;
    /**
     * Country
     */
    country: string;
    /**
     * Lookup suggestion identifier from address autocomplete
     */
    lookupSuggestionId?: string | null;
};
export namespace ClientSearchAddressResponseDto {
    /**
     * Type of address
     */
    export enum addressType {
        BILLING_ADDRESS = 'BILLING_ADDRESS',
        BRANCH_ADDRESS = 'BRANCH_ADDRESS',
        BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
        CORRESPONDENCE_ADDRESS = 'CORRESPONDENCE_ADDRESS',
        HOME_ADDRESS = 'HOME_ADDRESS',
        OTHER = 'OTHER',
        REGISTERED_ADDRESS = 'REGISTERED_ADDRESS',
        SITE_ADDRESS = 'SITE_ADDRESS',
    }
}

